import { AUTOCOMPLETE_FIELD_TYPE, INTEGER_RANGE_FIELD_TYPE, NUMERIC_RANGE_FIELD_TYPE, TEXT_FIELD_TYPE } from "../../helpers/constants";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";
import i18n from "../../i18n";
import { getTranslatedList } from "../../helpers/methods";


export const MATERIAL_REGISTRY_TABLE_NAME = "material_registry_table"

export const MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG = [
  {
    name: "item",
    getValueCallback: (rowData) => rowData.item,
    label: i18n.t("table.material_registry_table.item"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "part_name",
    getValueCallback: (rowData) => rowData.part_name,
    label: i18n.t("table.material_registry_table.part_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "part_suplier",
    getValueCallback: (rowData) => rowData.part_suplier,
    label: i18n.t("table.material_registry_table.producer"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.part_supliers,
      isObjectOption: true,
      optionLabelKey: "subcontractor_short_name",
      addNewValue: false,
      multiple: true,
      disableClearable: true,
      style: { minWidth: "150px" },
    }),
  },
  {
    name: "part_type",
    getValueCallback: (rowData) => rowData.part_type,
    label: i18n.t("table.material_registry_table.part_type"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "part_desc",
    getValueCallback: (rowData) => rowData.part_desc,
    label: i18n.t("table.material_registry_table.part_desc"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "part_lead_time",
    getValueCallback: (rowData) => rowData.part_lead_time,
    label: i18n.t("table.material_registry_table.part_lead_time"),
    filterType: INTEGER_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "part_unit",
    getValueCallback: (rowData) =>  i18n.t(`other.units.${rowData.part_unit}`) ,
    label: i18n.t("table.material_registry_table.unit"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options : getTranslatedList(filteringData?.value?.part_unit, "other.units."),
      isObjectOption: true,
      optionLabelKey: "name",
      addNewValue: false,
      multiple: true,
      disableClearable: true,
      style: { minWidth: "150px" },
    }),
  },
  {
    name: "part_package",
    getValueCallback: (rowData) => rowData.part_package,
    label: i18n.t("table.material_registry_table.part_package"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "part_carbon_footprint",
    getValueCallback: (rowData) => rowData.part_carbon_footprint,
    label: i18n.t("table.material_registry_table.part_carbon_footprint"),
    filterType: NUMERIC_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "part_note",
    getValueCallback: (rowData) => rowData.part_note,
    label: i18n.t("table.material_registry_table.part_note"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "edit",
    getValueCallback: (rowData, onClickEdit, onClickCopy, hasPermission) => {
      const content = (
          <ModeEditOutlineOutlined
            onClick={(e) => onClickEdit(e, rowData.id)}
          />
      );
      return  hasPermission && rowData.part_active ? content : "";
    },
    filterType: null,
    label: i18n.t("table.material_registry_table.edit"),
    excludedFromExport: true,
    allowChangeVisibility: false,

  },
  {
    name: "copy",
    getValueCallback: (rowData, onClickEdit, onClickCopy, hasPermission) => {
      const content = (
          <ContentCopyIcon
            onClick={(e) => onClickCopy(e, rowData.id)}
          />
      );
      return  hasPermission && rowData.part_active ? content : "";
    },
    filterType: null,
    label: i18n.t("table.material_registry_table.copy"),
    excludedFromExport: true,
    allowChangeVisibility: false,

  }
];
